import { Roles } from "../../../mp-utils/generic-utils"
import parseSnapshot from "../../../mp-utils/generic-utils/common/parseSnapshot"
import { getSchoolYear } from "../../../mp-utils/generic-utils"
import { db } from "../../../mp-database"

import getTruthyKeys from "../../helpers/getTruthyKeys"

import _ from "lodash"

import { AdminFilterActionTypeEnums } from "../../context/reducers"

const PAGE_SIZE = 50

export const getSearchedDistricts = (
  dispatch,
  searchText,
  filters,
  user,
  cursor
) => {
  let action = cursor ? addFilterData : setFiltersData
  let loadType = cursor ? "isPaginatingDistricts" : "isFetchingDistricts"
  dispatch(
    setFiltersData({
      [loadType]: true
    })
  )

  const onResponse = sn => {
    let districts = []

    let lastDoc = sn.docs.length ? sn.docs[sn.docs.length - 1] : null
    if (sn?.docs?.length < PAGE_SIZE) {
      lastDoc = null
    }

    if (sn.forEach) {
      sn.forEach((item, index) => {
        let data = item.data()
        if (data?.deleted !== true) {
          districts.push({ label: data.name, value: data.id })
        }
      })
    }

    return dispatch(
      action({
        districts: districts,
        [loadType]: false,
        optionsKey: "districts",
        districtsCursor: lastDoc
      })
    )
  }

  let dbQuery = db.collection("districts")

  if (user.role === Roles.Instructor) {
    dbQuery = dbQuery.where(`educators`, "array-contains", user.id)
  }

  if (searchText) {
    dbQuery = dbQuery
      .where("name_lower", ">=", searchText.toLowerCase())
      .where("name_lower", "<=", searchText.toLowerCase() + "\uf8ff")
  }

  dbQuery = dbQuery.orderBy("name_lower")

  if (cursor) {
    dbQuery = dbQuery.startAfter(cursor)
  }

  dbQuery
    .limit(PAGE_SIZE)
    .get()
    .then(sn => onResponse(sn))
    .catch(err => {
      dispatch(
        setFiltersData({
          districts: [],
          [loadType]: false,
          err: err
        })
      )
    })
}

export const getSearchedSchools = (
  dispatch,
  searchText,
  filters,
  user,
  cursor
) => {
  // const classId = filters["class"]
  // const teacherId = filters["teacher"]
  // const schoolId = filters["school"] || user["school"]
  const districtId = filters["district"] || user["schoolDistrict"]

  if (districtId === undefined) return

  // let action = cursor ? addFilterData : setFiltersData
  const loadType = "isFetchingSchools"

  dispatch(
    setFiltersData({
      [loadType]: true
    })
  )

  let querySchoolIds = []
  if (
    user.role === Roles.Teacher ||
    user.role === Roles.Instructor ||
    (user.role === Roles.School_Admin && user.isTeacher)
  ) {
    if (user?.schools?.length > 0) {
      querySchoolIds = user.schools
    } else {
      querySchoolIds = user.school ? [user.school] : []
    }
  }

  let querySchoolIdChunks = _.chunk(querySchoolIds, 10)

  if (querySchoolIdChunks.length === 0) {
    // If there is no schoolIds, we still want to run the query so we add an empty array to run query once
    querySchoolIdChunks = [[]]
  }

  const promises = []
  for (const schoolIdChunk of querySchoolIdChunks) {
    let dbQuery = db.collection("schools")
    if (schoolIdChunk.length > 0) {
      dbQuery = dbQuery.where("id", "in", schoolIdChunk)
    }

    if (districtId) {
      dbQuery = dbQuery.where("district", "==", districtId)
    }

    if (user.role === Roles.Instructor) {
      dbQuery = dbQuery.where(`educators`, "array-contains", user.id)
    }

    if (searchText) {
      dbQuery = dbQuery
        .where("name_lower", ">=", (searchText || "").toLowerCase())
        .where("name_lower", "<=", (searchText || "").toLowerCase() + "\uf8ff")
    }

    promises.push(dbQuery.get())
  }

  Promise.all(promises)
    .then(qss => {
      let dispatchSchoolsResults = []
      for (const qs of qss) {
        for (const doc of qs.docs) {
          if (doc.exists) {
            let data = doc.data()
            if (data?.deleted !== true) {
              dispatchSchoolsResults.push({
                label: data.name,
                value: data.id
              })
            }
          }
        }
      }

      // sort dispatchSchoolsResults, by name_lower
      dispatchSchoolsResults.sort((a, b) => {
        return (a.label ?? "").localeCompare(b.label ?? "")
      })

      const singleSchool =
        dispatchSchoolsResults.length === 1 && !searchText
          ? dispatchSchoolsResults[0]
          : null

      dispatch(
        setFiltersData({
          optionsKey: "schools",
          schoolsCursor: null,
          schools: dispatchSchoolsResults,
          ...(!!singleSchool
            ? { school: singleSchool, isDistrictWithSingleSchool: true }
            : { isDistrictWithSingleSchool: false }),
          [loadType]: false
        })
      )
    })
    .catch(err => {
      console.log("Error", err)
      return dispatch(
        setFiltersData({
          schools: [],
          [loadType]: false,
          error: err
        })
      )
    })
}

export const getSearchedTeachers = (
  dispatch,
  searchText,
  filters,
  user,
  cursor
) => {
  const classId = filters["class"]
  const teacherId = filters["teacher"]
  const schoolId = filters["school"] || user["school"]
  const districtId = filters["district"] || user["schoolDistrict"]

  if (schoolId === undefined) return

  const loadType = cursor ? "isPaginatingTeachers" : "isFetchingTeachers"

  dispatch(
    setFiltersData({
      [loadType]: true
    })
  )

  let query = db.collection("educators")

  const queryPromises = []
  if (searchText) {
    const fields = ["firstName_lower", "lastName_lower", "fullname_lower"]
    query = query.where("isTeacher", "==", true)

    fields.forEach(field => {
      queryPromises.push(
        query
          .where("school", "==", schoolId)
          .where(field, ">=", (searchText || "").toLowerCase())
          .where(field, "<=", (searchText || "").toLowerCase() + "\uf8ff")
          .where("isTeacher", "==", true)
          .get()
          .then(docs => parseSnapshot(docs))
      )
      queryPromises.push(
        query
          .where("schools", "array-contains", schoolId)
          .where(field, ">=", (searchText || "").toLowerCase())
          .where(field, "<=", (searchText || "").toLowerCase() + "\uf8ff")
          .where("isTeacher", "==", true)
          .get()
          .then(docs => parseSnapshot(docs))
      )
      //TODO: make it work for Instructor role
      // queryPromises.push(
      //   query
      //     .where("school", "==", school)
      //     .where(field, ">=", (searchText || "").toLowerCase())
      //     .where(field, "<=", (searchText || "").toLowerCase() + "\uf8ff")
      //     .where("isTeacher", "==", true)
      //     .get()
      //     .then(docs => parseSnapshot(docs))
      // )
      queryPromises.push(
        query
          .where("schools", "array-contains", schoolId)
          .where(field, ">=", (searchText || "").toLowerCase())
          .where(field, "<=", (searchText || "").toLowerCase() + "\uf8ff")
          .where("isTeacher", "==", true)
          .get()
          .then(docs => parseSnapshot(docs))
      )
    })
  } else if (schoolId) {
    query = query.where("isTeacher", "==", true)

    queryPromises.push(
      query
        .where("school", "==", schoolId)
        .where("isTeacher", "==", true)
        .get()
        .then(docs => parseSnapshot(docs))
    )
    queryPromises.push(
      query
        .where("schools", "array-contains", schoolId)
        .where("isTeacher", "==", true)
        .get()
        .then(docs => parseSnapshot(docs))
    )
    queryPromises.push(
      query
        .where("school", "==", schoolId)
        .where("isTeacher", "==", true)
        .get()
        .then(docs => parseSnapshot(docs))
    )
    queryPromises.push(
      query
        .where("schools", "array-contains", schoolId)
        .where("isTeacher", "==", true)
        .get()
        .then(docs => parseSnapshot(docs))
    )
  }

  if (queryPromises.length) {
    let docs = {}
    Promise.all(queryPromises)
      .then(resolvedQueries => {
        resolvedQueries.forEach(query => {
          docs = {
            ...docs,
            ...query
          }
        })

        let teachers = Object.values(docs)
        teachers.sort((a, b) => a.fullname_lower - b.fullname_lower)

        return dispatch(
          setFiltersData({
            teachers: teachers.map(item => ({
              label: item.fullName,
              value: item.id
            })),
            teachersCursor: null,
            [loadType]: false
          })
        )
      })
      .catch(err => {
        console.log(err)
        return dispatch(
          setFiltersData({
            teachers: [],
            [loadType]: false,
            error: err
          })
        )
      })
  } else {
    return dispatch(
      setFiltersData({
        teachers: [],
        [loadType]: false
      })
    )
  }
}

export const getSearchedClasses = (
  dispatch,
  searchText,
  filters,
  user,
  cursor
) => {
  // const loadType = cursor ? "isPaginatingClasses" : "isFetchingClasses"
  const loadType = "isFetchingClasses"

  const district = filters["district"] || user["schoolDistrict"]
  const school = filters["school"] || user["school"]
  const teacher = filters["teacher"]
  const classId = filters["class"]

  if (!teacher && user.role !== "Instructor" && user.role !== "Teacher") return

  dispatch(
    setFiltersData({
      [loadType]: true
    })
  )

  // Apparently we haven't used school year in the past and we can't start now
  const curYear = getSchoolYear()

  let query = db
    .collection("classes")
    .where("schoolYear", "in", [curYear.year, curYear.year.toString()])

  // if (cursor) {
  //   query = query.startAfter(cursor)
  // }

  if (teacher) {
    query = query.where("teacher", "==", teacher)
  } else if (user.role === "Instructor" || user.role === "Teacher") {
    query = query.where("teacher", "==", user.id)
  }
  if (district) {
    query = query.where("district", "==", district)
  }
  if (school) {
    query = query.where("school", "==", school)
  }

  if (searchText) {
    query = query
      .where("name_lower", ">=", (searchText || "").toLowerCase())
      .where("name_lower", "<=", (searchText || "").toLowerCase() + "\uf8ff")
  }

  // query = query.orderBy("name_lower")

  query
    .get()
    .then(docs => {
      let classes = []
      docs.forEach(doc => {
        if (doc.exists) {
          let item = doc.data()
          if (item.deleted !== true) {
            classes.push({
              label: item.name,
              value: item.id
            })
          }
        }
      })
      classes.sort((a, b) => {
        return a.name - b.name
      })

      return dispatch(
        setFiltersData({
          classes: classes,
          classesCursor: null,
          [loadType]: false
        })
      )
    })
    .catch(err => {
      console.log(err)
      return dispatch(
        setFiltersData({
          classes: [],
          [loadType]: false,
          error: err
        })
      )
    })
}

export const getSearchedStudents = async (
  dispatch,
  searchText,
  filters,
  user,
  cursor
) => {
  const classId = filters["class"]
  let teacherId = filters["teacher"]
  const schoolId = filters["school"] || user["school"]
  const districtId = filters["district"] || user["schoolDistrict"]

  if (!teacherId) {
    if (user["role"] == "Teacher") {
      teacherId = user["id"]
    }
  }

  if (districtId === undefined) return

  let query = db.collection("students")

  // determine if getting all students or not for a district/school
  // if teacher is selected then we will filter based on their
  // active classes
  if (teacherId) {
    const loadType = "isFetchingStudents"
    dispatch(
      setFiltersData({
        [loadType]: true
      })
    )

    // do teacher student query
    const curYear = getSchoolYear()
    let classStudents = []

    let cquery = db.collection("classes")

    if (classId) {
      await cquery
        .doc(classId)
        .get()
        .then(doc => {
          if (doc.exists) {
            const data = doc.data()
            if (!data?.deleted) {
              classStudents = getTruthyKeys(data.students)
            }
          }
        })
        .catch(err => {
          console.log("fetching teacher class err", err)
          return dispatch(
            setFiltersData({
              [loadType]: false,
              studentsCursor: null,
              students: [],
              error: err
            })
          )
        })
    } else {
      const docs = await cquery
        .where("district", "==", districtId)
        .where("school", "==", schoolId)
        .where("schoolYear", "in", [curYear.year, curYear.year.toString()])
        .where("teacher", "==", teacherId)
        .get()
        .then(snapshot => parseSnapshot(snapshot))
        .catch(err => {
          console.log("fetching student classes err", err)
          return dispatch(
            action({
              optionsKey: "students",
              students: [],
              [loadType]: false,
              error: err
            })
          )
        })

      Object.keys(docs).forEach(key => {
        const newStudents = getTruthyKeys(docs[key].students)
        classStudents = [...classStudents, ...newStudents]
      })
    }

    const chunks = _.chunk(classStudents, 10)

    let docs = {}

    // await async.eachOfLimit(chunks, 4, async (chunk) => {
    for (const chunk of chunks) {
      const partialStudents = await db
        .collection("students")
        .where("id", "in", chunk)
        .where("schoolDistrict", "==", districtId)
        .get()
        .then(snapshot => parseSnapshot(snapshot))
        .catch(err => {
          console.log("fetching students in classes err", err)
          return dispatch(
            action({
              optionsKey: "students",
              [loadType]: false,
              students: [],
              error: err
            })
          )
        })

      docs = {
        ...docs,
        ...partialStudents
      }
    }

    let students = Object.values(docs)

    students.sort((a, b) => a.fullname_lower - b.fullname_lower)

    if (searchText) {
      students = students.filter(s =>
        s.fullname_lower.includes(searchText.toLowerCase())
      )
    }
    return dispatch(
      setFiltersData({
        students: students.map(item => ({
          label: item.fullName,
          value: item.id
        })),
        studentsCursor: null,
        [loadType]: false
      })
    )
  } else {
    // do district/school query
    const loadType = cursor ? "isPaginatingStudents" : "isFetchingStudents"

    if (loadType === "isFetchingStudents") {
      dispatch(
        setFiltersData({
          [loadType]: true
        })
      )
    } else {
      dispatch(
        addFilterData({
          optionsKey: "students",
          [loadType]: true
        })
      )
    }

    if (schoolId) {
      query = query.where("school", "==", schoolId)
    }

    if (districtId) {
      query = query.where("schoolDistrict", "==", districtId)
    }

    if (searchText) {
      // only search when 3 or more characters
      if (searchText.length < 3) {
        return dispatch(
          addFilterData({
            optionsKey: "students",
            students: [],
            [loadType]: false
          })
        )
      }

      const queryPromises = []
      const fields = ["firstName_lower", "lastName_lower", "fullname_lower"]
      fields.forEach(field => {
        queryPromises.push(
          query
            .where(field, ">=", (searchText || "").toLowerCase())
            .where(field, "<=", (searchText || "").toLowerCase() + "\uf8ff")
            .get()
            .then(docs => parseSnapshot(docs))
        )
      })

      let docs = {}

      Promise.all(queryPromises)
        .then(resolvedQueries => {
          resolvedQueries.forEach(query => {
            docs = {
              ...docs,
              ...query
            }
          })

          let students = Object.values(docs)

          if (classId) {
            students = students.filter(
              student => student.classes?.[classId] === true
            )
          }
          students.sort((a, b) => a.fullname_lower - b.fullname_lower)
          return dispatch(
            setFiltersData({
              students: students.map(item => ({
                label: item.fullName,
                value: item.id
              })),
              studentsCursor: null,
              [loadType]: false
            })
          )
        })
        .catch(err => {
          console.log(err)
          return dispatch(
            setFiltersData({
              students: [],
              studentsCursor: null,
              [loadType]: false,
              error: err
            })
          )
        })
    } else {
      // not searching so just do normal query
      query = query.orderBy("fullname_lower")

      let action = setFiltersData

      if (cursor) {
        action = addFilterData
        query = query.startAfter(cursor)
      }

      query
        .limit(PAGE_SIZE)
        .get()
        .then(qs => {
          let students = []
          let lastDoc = qs.docs.length ? qs.docs[qs.docs.length - 1] : null
          if (qs?.docs?.length < PAGE_SIZE) {
            lastDoc = null
          }
          qs.forEach(
            doc =>
              doc.exists && !doc.data()?.deleted && students.push(doc.data())
          )

          if (classId) {
            students = students.filter(student => {
              return student.classes?.[classId] === true
            })
          }

          students.sort((a, b) => a.fullname_lower - b.fullname_lower)

          return dispatch(
            action({
              studentsCursor: lastDoc,
              optionsKey: "students",
              students: students.map(item => ({
                label: item.fullName,
                value: item.id
              })),
              [loadType]: false
            })
          )
        })
        .catch(err => {
          console.log("fetcing students err", err)
          return dispatch(
            action({
              optionsKey: "students",
              students: [],
              [loadType]: false,
              error: err
            })
          )
        })
    }
  }
}

export const setGlobalSearchFilters = searchedObject => {
  return dispatch => {
    dispatch(
      setFiltersData({
        ...searchedObject
      })
    )
  }
}
export const addFilterData = payload => {
  return {
    type: AdminFilterActionTypeEnums.FilterOptionsAppend,
    payload
  }
}

export const setFiltersData = payload => {
  return {
    type: AdminFilterActionTypeEnums.FilterOptionsModify,
    payload
  }
}

export const emptyFilters = () => {
  return {
    type: AdminFilterActionTypeEnums.FilterOptionsClear
  }
}
